// extracted by mini-css-extract-plugin
module.exports = {"navBtns":"navigation_navBtns__3hA3Y","button":"navigation_button__az5mB"};